jQuery(function () {
  // Footnotes, with thanks to https://dev.to/aellon/add-footnotes-in-wordpress-without-a-plugin-32do

  // set ID for each <li></li> in .footnotes
  jQuery(".footnotes li").each(function (index, value) {
    jQuery(this).attr("id", "fn" + (index + 1));
  });

  // get each footlink from the content
  var links = document.querySelectorAll('a[href*="#fn"]');

  // add a class of "footnote-link" to each link to reference later for the popover
  jQuery(links).each(function () {
    var link = this;
    jQuery(link).addClass(function () {
      return "footnote-link";
    });
  });

  // get the formatted ID and the footnote text of all of the <li></li>
  var footnoteArray = new Array();
  jQuery(".footnotes li").each(function (id, value) {
    var formattedID = "#" + jQuery(this).attr("id");

    // add the arrow and number before the text (feel free to skip this style choice)
    var text = "&rarr; " + (id + 1) + ". " + this.innerText;
    footnoteArray.push({ formattedID, text });
  });

  // get the IDs from the footnoteArray
  var footnoteIDs = jQuery.map(footnoteArray, function (value, key) {
    return value.formattedID;
  });

  // make a new array that contains the HTML link values
  var LinkArray = new Array();
  jQuery("#main .footnote-link").each(function (id, value) {
    LinkArray.push(value.outerHTML);
  });

  // loop over all of the links to the footnotes
  jQuery.each(LinkArray, function (ind, value) {
    var link = value;
    var footnoteText = "";
    var linkHref = jQuery(link).attr("href");

    // check if there is a match between the href attribute values and any of the footnoteIDs
    if (jQuery.inArray(linkHref, footnoteIDs) != -1) {
      // if there is a match, get the footnote text from that matching value
      footnoteText = footnoteArray.find((x) => x.formattedID === linkHref).text;

      // get the link whose ID matches this one and wrap it in a button with the corresponding text for the popover
      jQuery("#main a[href$='" + linkHref + "']").wrap(function () {
        return (
          '<a class="footnote-popover" data-bs-toggle="popover" data-bs-trigger="hover" data-bs-content="' +
          footnoteText +
          '" ><sup></sup></a>'
        );
      });
    }
  });
  jQuery(".footnote-popover").popover({
    container: "body",
  });

  // Set active state on sidebar menu items
  jQuery(".card-body").click(function () {
    jQuery(".card-body.active").removeClass("active");
    jQuery(this).toggleClass("active");
  });

  var hash = window.location.hash;
  var path =
    window.location.protocol +
    "//" +
    window.location.host +
    window.location.pathname;
  if (window.location.search.indexOf("?s=") > -1) {
    return;
  }
  if (window.location.host === "localhost:3000") {
    var path = "//" + window.location.host + window.location.pathname;
  }
  if (hash) {
    jQuery('a[href="' + path + '"]').toggleClass("active");
    jQuery('a[href="' + path + '"]')
      .closest(".card")
      .children(".collapse")
      .collapse("show");
    jQuery('a[href$="' + hash + '"]')
      .parent()
      .toggleClass("active");
  } else {
    jQuery('a[href="' + path + '"]').toggleClass("active");
  }

  // On single chapter pages, change Read More button text on text boxes when clicked
  jQuery(".rm-collapse-button").click(function () {
    var target = jQuery(this).data("target");
    jQuery(target).on("hidden.bs.collapse", function () {
      jQuery('*[data-target="' + target + '"]').text("Read more");
    });
    jQuery(target).on("shown.bs.collapse", function () {
      jQuery('*[data-target="' + target + '"]').text("Read less");
    });
  });
});
